/* ========== 対象処理 ========== */
// マイページ表示
// 1. ログイン
// 2. 来店予約ページ
// 3. マイページ
// 4. 会員情報ページ

document.addEventListener("DOMContentLoaded", function () {
  const loginButton = document.getElementById('login_button');
  const mypageArea = document.getElementById('mypage_area');
  const accountArea = document.getElementById('account_area');
  const reservationArea = document.getElementById('reservation_area');
  const addresses = document.querySelector('.customer.addresses ._list');

  // ログインページ
  const login_form = document.getElementById("login_form");

  //redirectの初期パラメーター
  const url = new URL(window.location.href);
  const params = url.searchParams;
  if( params.get('redirectUrl') ){
    let login_redirect_url = document.getElementById("login_redirect_url")
    login_redirect_url.value = encodeURI(params.get('redirectUrl'))
  }else if( params.get('return_url') ){
    let login_redirect_url = document.getElementById("login_redirect_url");
    let adjust_login_redirect_url = `https://${location.hostname}` + encodeURI(params.get('return_url'));
    login_redirect_url.value = adjust_login_redirect_url;
  }else if( params.get('checkout_url') ){
    let login_redirect_url = document.getElementById("login_redirect_url")
    login_redirect_url.value = `https://${location.hostname}` + encodeURI(params.get('checkout_url'))
  }

  if (loginButton) {
    login_form.addEventListener("submit", (e) => {
      e.preventDefault();
      loginCustomer(loginButton);
    });
  }

  // 来店予約ページ
  if (reservationArea) {
    setReservationArea();
  }

  // マイページ
  if (mypageArea) {
    setMypage();
  }

  // 会員情報ページ
  if (accountArea) {
    setCustomer();
    let furigana = document.querySelector('.furigana');
    changeLang(furigana);
  }

  // 配送先リスト
  if (addresses) {
    setAddress();
  }

  // webview
  if ( isYappliSmartphone() ) {

    if ( location.pathname === '/account' ) {

      // ログアウト処理
      const logoutButton = document.querySelector('a[href^="/account/logout"]');
      logoutButton.addEventListener('click', (e) => {
        e.preventDefault(); // リンクの遷移をキャンセル 
        fetch(logoutButton.getAttribute('href')).then((res) => {
          if (res.ok) {
            window.location = 'native:/tab/custom/4ba84f9e';
          }
        });
      });        
    }

    if ( location.pathname === '/account/login' ) {

      // 会員登録ボタンの出しわけ、スタイル変更
      const registerButtonStyle = document.querySelector('.register_button--app');
      registerButtonStyle.style.color = '#333';
      registerButtonStyle.style.backgroundColor = '#fff';
      registerButtonStyle.style.borderWidth = '1px';
      registerButtonStyle.style.borderStyle = 'solid';
      registerButtonStyle.style.borderColor = '#333';
      document.querySelector('.register_button:not(.register_button--app)').remove();
      document.querySelector('.register_button--app').style.display = 'inline-block';

      document.querySelector( 'input#app_flag' ).value = '1';
      document.querySelector( '#app_register' ).addEventListener( 'click', (e) => {
        e.preventDefault();
        window.location = '/pages/app_registration';
      })
      
      // ログインせずに利用ボタンの表示制御
      if ( get_param('skip') ) {
        document.querySelector( '#not_login_button' ).style.display = 'block';
        document.querySelector( '#not_login_button' ).addEventListener( 'click', () => {
          window.location = 'native:/tab/redirect/6649ea50';
        })
      }

    }
  }
  else {
    document.querySelector('.register_button--app').remove();
  }

});

// ログイン処理
const loginCustomer = async (loginButton) => {
  const url = `${APP_PROXY_URL}/api/login`;
  let errorMessage = document.getElementById('error_message');
  errorMessage.innerText = '';
  errorMessage.style.display = 'none';
  btnLoading(loginButton);

  const params = validateLogin();
  if (!params) {
    btnStopLoading(loginButton);
    return;
  }

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params),
      redirect: 'manual'
    });

    // IPブロック時のリダイレクト検知（redirect: 'manual' により、301/302/3xx すべてが opaqueredirect として返る）
    if (response.type === 'opaqueredirect') {
      window.location = '/pages/403';
      return;
    }

    if (!response || response.status == 500) {
      throw new Error('サーバーエラーが発生しました');
    }

    const res = await response.json();
    if (res.message == 'ok') {
      // Yappliへの連携
      if ( isYappliSmartphone()) {
        if ( res.memberCode && res.token ) {
          sendId(JSON.stringify({registered_id:res.memberCode,token:res.token}));
        } else {
          throw new Error();
        }
      }

      if ( isYappliSmartphone()) {
        setTimeout(() => {
          window.location = getMultipassUrl(res.multipassToken);
        }, 1500);
      } else {
        window.location = getMultipassUrl(res.multipassToken);
      }
    }
    else {
      throw new Error(res.message);
    }
  } catch (error) {
    if(error.message == undefined || error.message == '' ){
      errorMessage.innerText = 'サーバーエラーが発生しました';
    }else{
      errorMessage.innerText = error.message;
    }
    errorMessage.style.display = 'block';
    btnStopLoading(loginButton);
  }

};

// 来店予約用iframe表示
const setReservationArea = async () => {
  const customer = await getCustomer();

  if (customer === null) {
    return;
  }

  const url = new URL(`${APP_PROXY_URL}/api/customer/store_reservation_token`);
  let iframe = document.getElementById('reservation_iframe');
  let errorMessage = document.getElementById('error_message');
  errorMessage.innerText = '';

  const res = await fetchGetMethod(url);
  //get event_code
  const currentUrl = new URL(window.location.href);
  const params = currentUrl.searchParams;
  const event_code = (params.get('event_code')) ? encodeURI(params.get('event_code')): false;

  if (res.message == 'ok') {
    if(event_code){
      iframe.src = `${RESERVATION_HOST}/user/IM-booking-visit-store-direct/${event_code}?auth=${res.token}`;
    }else{
      iframe.src = `${RESERVATION_HOST}/user/IM-booking-event_mypage.html?auth=${res.token}`;
    }
  } else {
    iframe.style.display = 'none';
    errorMessage.innerText = res.message;
  }
};

// マイページ表示
const setMypage = async () => {
  const customer = await getCustomer();

  if (customer === null) {
    return;
  }
  //顧客barcode
  JsBarcode("#account_barcode", customer.memberCode, {
    width: 5,
    height: 190,
    displayValue: false
  });
  document.querySelector('._name').innerText = `${customer.lastName} ${customer.firstName}様`;
  document.querySelector('._number').innerText = `会員番号：${customer.memberCode}`;
  document.getElementById('account_number').innerText = `${customer.memberCode}`;
  setPointOverview(customer);
};

// 会員情報ページ表示
const setCustomer = async () => {
  const customer = await getCustomer();

  if (customer === null) {
    return;
  }

  setCustomerFields(customer);
};

// 会員情報ページ設定
const setCustomerFields = (customer) => {
  let mainInfo = document.querySelectorAll('.main_info ._customerData');
  let email = document.querySelector('.--mail ._customerData');
  let phone = document.querySelector('.--phone ._customerData');

  mainInfo[0].innerText = `${customer.lastName} ${customer.firstName}`;
  mainInfo[1].innerText = `${customer.lastKana} ${customer.firstKana}`;

  if (customer.country == 'JP') {
    mainInfo[2].innerText = '日本';
    mainInfo[3].innerText = customer.postalCode;
    mainInfo[4].innerText = customer.prefecture;
  } else {
    mainInfo[2].innerText = 'その他';
    setEditAddress();
  }

  mainInfo[5].innerText = customer.countyCityAddress + customer.townAddress + customer.buildingName;
  mainInfo[6].innerText = setSex(customer);
  mainInfo[7].innerText = setBirthday(customer);
  setNewsletter(customer, mainInfo[8]);
  mainInfo[9].innerText = setShopDM(customer);
  setBlandList(customer, mainInfo[10]);
  email.innerText = customer.email;
  phone.innerText = customer.phoneNumber;
};

// 配送先リスト住所設定
const setAddress = async () => {
  const customer = await getCustomer();

  if (customer === null) {
    return;
  }

  let address = document.querySelector('.customer-address');
  let tel = document.querySelector('.customer-tel');

  let zip = customer.postalCode ? `〒${customer.postalCode.substr(0,3)}-${customer.postalCode.substr(3)}` : '';
  address.innerHTML = `${zip}<br>${customer.prefecture}${customer.countyCityAddress}${customer.townAddress}${customer.buildingName}`;
  tel.innerHTML = customer.phoneNumber ? `Tel. ${customer.phoneNumber}` : '';
};

// Yappli SDK
// const sendId = function(memberObj) {
//   Yappli.sendRegisteredId(memberObj, function (result, message) {
//     if (!result) {
//       sendId(memberObj);
//     }
//   });
// }

function sendId (memberObj) {
  Yappli.sendRegisteredId(memberObj, function (result, message) {
    if (!result) {
      sendId(memberObj);
    }
  });
}

// 特定のパラメータを取得
const get_param = function(param) {
  const queryString = window.location.search,
        params = new URLSearchParams(queryString);
  return params.get(param);
}

// スマートフォンかつUAに「Yappli」が含まれているかを判定する関数
const isYappliSmartphone = function() {
  const userAgent = navigator.userAgent;
  return /iPhone|iPad|iPod|Android/i.test(userAgent) && userAgent.includes('Yappli');
}